import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import * as InAppHelper from "helpers/InApp.helper";
import * as CommonHelper from "helpers/Common.helper";

const BASE_PATH = '/agency';
const MenuComponent = (props: any) => {
    const { pathname } = useLocation();
    const { showMessageBadge, showHubBadge, showNoticeBadge } = props;

    const [isShowMainMenu, setIsShowMainMenu] = useState(false);
    const [menuPb, setMenuPb] = useState('pb-4');
    const [safeAreaBottom, setSafeAreaBottom] = useState(0);

    const getIconSrc = (path: string, icon: string, needSamePathName = false) => {
        if (needSamePathName) {
            if (pathname === path) {
                return `./imgs/icons/${icon}-active.svg`;
            } else {
                return `./imgs/icons/${icon}.svg`;
            }
        } else {
            if (pathname.startsWith(path)) {
                return `./imgs/icons/${icon}-active.svg`;
            } else {
                return `./imgs/icons/${icon}.svg`;
            }
        }
    };

    const updateMenuPb = async () => {
        const isIos = await InAppHelper.getIsIos();
        if (!isIos) {
            setMenuPb("pb-8");
        }
    }

    useEffect(() => {
        setIsShowMainMenu(pathname === BASE_PATH);
        if (pathname.startsWith(`${BASE_PATH}/favorite`) ||
            pathname.startsWith(`${BASE_PATH}/hub`) ||
            pathname.startsWith(`${BASE_PATH}/casting`)) {
            setIsShowMainMenu(false);
        } else {
            setIsShowMainMenu(true);
        }

        updateMenuPb();

        // 네비게이션 바 높이 가져오기
        // const navBarHeight = CommonHelper.getNavigationBarHeight();
        // setSafeAreaBottom(navBarHeight);
        // console.log('네비게이션 바 높이:', navBarHeight + 'px');

        // if (!InAppHelper.isInApp()) {
        //     // 앱이 아닌 경우 기본 패딩 + 네비게이션 바 높이
        //     const calculatedPadding = CommonHelper.calculateMenuPadding();
        //     setMenuPb(calculatedPadding);
        //     console.log('계산된 메뉴 패딩:', calculatedPadding);
        // } else {
        //     // 앱인 경우 네비게이션 바 높이만 고려
        //     if (navBarHeight > 0) {
        //         const calculatedPadding = CommonHelper.calculateMenuPadding();
        //         setMenuPb(calculatedPadding);
        //         console.log('앱 내 네비게이션 바 고려 패딩:', calculatedPadding);
        //     } else {
        //         setMenuPb('pb-4');
        //     }
        // }

    }, [pathname]);

    // 윈도우 리사이즈 이벤트로 네비게이션 바 높이 동적 감지
    // useEffect(() => {
    //     const handleResize = () => {
    //         const navBarHeight = CommonHelper.getNavigationBarHeight();
    //         setSafeAreaBottom(navBarHeight);

    //         if (!InAppHelper.isInApp()) {
    //             const calculatedPadding = CommonHelper.calculateMenuPadding();
    //             setMenuPb(calculatedPadding);
    //         } else {
    //             if (navBarHeight > 0) {
    //                 const calculatedPadding = CommonHelper.calculateMenuPadding();
    //                 setMenuPb(calculatedPadding);
    //             } else {
    //                 setMenuPb('pb-4');
    //             }
    //         }
    //     };

    //     // 초기 로드 후 약간의 지연을 두고 다시 측정 (네비게이션 바가 완전히 로드된 후)
    //     const timeoutId = setTimeout(handleResize, 100);

    //     // 윈도우 리사이즈 이벤트 리스너 등록
    //     window.addEventListener('resize', handleResize);
    //     window.addEventListener('orientationchange', handleResize);

    //     // visualViewport 이벤트 리스너 (iOS Safari)
    //     if (window.visualViewport) {
    //         window.visualViewport.addEventListener('resize', handleResize);
    //     }

    //     return () => {
    //         clearTimeout(timeoutId);
    //         window.removeEventListener('resize', handleResize);
    //         window.removeEventListener('orientationchange', handleResize);
    //         if (window.visualViewport) {
    //             window.visualViewport.removeEventListener('resize', handleResize);
    //         }
    //     };
    // }, []);

    return (
        <div className={`fixed bottom-0 left-0 right-0 flex justify-center ${menuPb}`}>
            {/* 메인 메뉴 */}
            <div className={`bg-gradient-to-r from-white/30 via-white/20 to-white/30 backdrop-blur-2xl border border-white/40 rounded-3xl shadow-2xl px-4 py-1 transition-all duration-300 ${isShowMainMenu ? 'opacity-100 translate-y-0 visible' : 'opacity-0 translate-y-full invisible'}`}>
                <div className="flex gap-2 sm:gap-4 md:gap-6">
                    {/* 홈 */}
                    <Link to={BASE_PATH} className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                            <img src={getIconSrc(BASE_PATH, 'icon-home', true)} alt={getLanguageValue(PAGE_TYPE.STUDENT, "mainMenu.txtHome")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] font-medium ${pathname === BASE_PATH ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                홈
                            </p>
                        </div>
                    </Link>

                    {/* 통계 */}
                    {/* <Link to={BASE_PATH + "/statistics"} className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50">
                            <img src={getIconSrc(BASE_PATH + "/statistics", 'icon-statistics')} alt={getLanguageValue(PAGE_TYPE.STUDENT, "mainMenu.txtCasting")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] font-medium ${pathname.startsWith(BASE_PATH + "/statistics") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                STATISTICS
                            </p>
                        </div>
                    </Link> */}

                    {/* 즐겨찾기 */}
                    <Link to={BASE_PATH + "/favorite/aspirant"} className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                            <img src={getIconSrc(BASE_PATH + "/favorite", 'icon-favorite')} alt={getLanguageValue(PAGE_TYPE.STUDENT, "mainMenu.txtFavorite")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] font-medium ${pathname.startsWith(BASE_PATH + "/favorite") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                즐겨찾기
                            </p>
                        </div>
                    </Link>

                    {/* 검색 */}
                    <Link to={BASE_PATH + "/search"} className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                            <img src={getIconSrc(BASE_PATH + "/search", 'icon-search')} alt={getLanguageValue(PAGE_TYPE.STUDENT, "mainMenu.txtSearch")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] font-medium ${pathname.startsWith(BASE_PATH + "/search") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                검색
                            </p>
                        </div>
                    </Link>

                    {/* 캐스팅 */}
                    <Link to={BASE_PATH + "/casting/message"} className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                            <img src={getIconSrc(BASE_PATH + "/message", 'icon-casting')} alt={getLanguageValue(PAGE_TYPE.STUDENT, "mainMenu.txtMessage")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] font-medium ${pathname.startsWith(BASE_PATH + "/message") ? 'text-[#CF3688]' : 'text-gray-700'} text-center whitespace-nowrap`}>
                                캐스팅
                            </p>
                            {showMessageBadge && (
                                <div className="absolute top-1 right-2">
                                    <span className="block text-xs text-white bg-[#cf3688] rounded-full w-2 h-2"></span>
                                </div>
                            )}
                        </div>
                    </Link>

                    {/* Hub */}
                    <Link to={BASE_PATH + "/hub/rank"} className="group flex flex-col items-center transition-all hover:scale-110">
                        <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                            <img src={getIconSrc(BASE_PATH + "/hub", 'icon-hub')} alt={getLanguageValue(PAGE_TYPE.STUDENT, "mainMenu.txtHub")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                            <p className={`text-[10px] font-medium ${pathname.startsWith(BASE_PATH + "/hub") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                허브
                            </p>
                            {showHubBadge && (
                                <div className="absolute top-1 right-2">
                                    <span className="block text-xs text-white bg-[#cf3688] rounded-full w-2 h-2"></span>
                                </div>
                            )}
                        </div>
                    </Link>
                </div>
            </div>

            {/* 즐겨찾기 메뉴 */}
            <div className={`absolute ${menuPb} bottom-0 left-0 right-0 flex justify-center transition-all duration-300 ${pathname.startsWith(`${BASE_PATH}/favorite`) ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-full invisible'}`}>
                <div className="bg-gradient-to-r from-white/30 via-white/20 to-white/30 backdrop-blur-2xl border border-white/40 rounded-3xl shadow-2xl px-4 py-1">
                    <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-center">
                        <Link to={BASE_PATH} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50 relative">
                                <img src="./imgs/icons/icon-arrow-left-1.svg" alt="Previous" className="w-4 h-4 sm:w-5 sm:h-5 mx-auto" />
                            </div>
                        </Link>
                        <div className="hidden sm:block h-5 w-[1px] bg-gray-200"></div>
                        <Link to={BASE_PATH + "/favorite/aspirant"} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                                <img src={getIconSrc(BASE_PATH + "/favorite/aspirant", 'icon-favorite-aspirants', true)} alt={getLanguageValue(PAGE_TYPE.AGENCY, "favoriteMenu.txtAspirant")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                                <p className={`text-[10px] font-medium ${pathname === (BASE_PATH + "/favorite/aspirant") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                    지망생
                                </p>
                            </div>
                        </Link>
                        <Link to={BASE_PATH + "/favorite/diary"} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                                <img src={getIconSrc(BASE_PATH + "/favorite/diary", 'icon-diary', true)} alt={getLanguageValue(PAGE_TYPE.AGENCY, "favoriteMenu.txtDiary")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                                <p className={`text-[10px] font-medium ${pathname === (BASE_PATH + "/favorite/diary") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                    다이어리
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

            {/* 메시지 메뉴 */}
            <div className={`absolute ${menuPb} bottom-0 left-0 right-0 flex justify-center transition-all duration-300 ${pathname.startsWith(`${BASE_PATH}/casting`) ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-full invisible'}`}>
                <div className="bg-gradient-to-r from-white/30 via-white/20 to-white/30 backdrop-blur-2xl border border-white/40 rounded-3xl shadow-2xl px-4 py-1">
                    <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-center">
                        <Link to={BASE_PATH} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50 relative">
                                <img src="./imgs/icons/icon-arrow-left-1.svg" alt="Previous" className="w-4 h-4 sm:w-5 sm:h-5 mx-auto" />
                            </div>
                        </Link>
                        <div className="hidden sm:block h-5 w-[1px] bg-gray-200"></div>
                        <Link to={BASE_PATH + "/casting"} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                                <img src={getIconSrc(BASE_PATH + "/casting", 'icon-summary', true)} alt={getLanguageValue(PAGE_TYPE.AGENCY, "castingMenu.txtSummary")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                                <p className={`text-[10px] font-medium ${pathname === (BASE_PATH + "/casting") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                    요약
                                </p>
                            </div>
                        </Link>
                        <Link to={BASE_PATH + "/casting/message"} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                                <img src={getIconSrc(BASE_PATH + "/casting/message", 'icon-message')} alt={getLanguageValue(PAGE_TYPE.AGENCY, "castingMenu.txtMessage")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                                <p className={`text-[10px] font-medium ${pathname === (BASE_PATH + "/casting/message") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                    메시지
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

            {/* Hub 메뉴 */}
            <div className={`absolute ${menuPb} bottom-0 left-0 right-0 flex justify-center transition-all duration-300 ${pathname.startsWith(`${BASE_PATH}/hub`) ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-full invisible'}`}>
                <div className="bg-gradient-to-r from-white/30 via-white/20 to-white/30 backdrop-blur-2xl border border-white/40 rounded-3xl shadow-2xl px-4 py-1">
                    <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-center">
                        <Link to={BASE_PATH} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50 relative">
                                <img src="./imgs/icons/icon-arrow-left-1.svg" alt="Previous" className="w-4 h-4 sm:w-5 sm:h-5 mx-auto" />
                            </div>
                        </Link>
                        <div className="hidden sm:block h-5 w-[1px] bg-gray-200"></div>
                        <Link to={BASE_PATH + "/hub/rank"} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                                <img src={getIconSrc(BASE_PATH + "/hub/rank", 'icon-rank')} alt={getLanguageValue(PAGE_TYPE.AGENCY, "hubMenu.txtRank")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                                <p className={`text-[10px] font-medium ${pathname === (BASE_PATH + "/hub/rank") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                    랭킹
                                </p>
                            </div>
                        </Link>
                        <Link to={BASE_PATH + "/hub/notice"} className="group flex flex-col items-center transition-all hover:scale-110">
                            <div className="p-2 sm:p-3 rounded-xl group-hover:bg-gray-50  relative">
                                <img src={getIconSrc(BASE_PATH + "/hub/notice", 'icon-notice')} alt={getLanguageValue(PAGE_TYPE.AGENCY, "hubMenu.txtNotice")} className="w-5 h-5 sm:w-6 sm:h-6 mx-auto mb-1" />
                                <p className={`text-[10px] font-medium ${pathname === (BASE_PATH + "/hub/notice") ? 'text-[#CF3688]' : 'text-gray-700'} text-center`}>
                                    공지
                                </p>
                                {showNoticeBadge && (
                                    <div className="absolute top-1 right-2">
                                        <span className="block text-xs text-white bg-[#cf3688] rounded-full w-2 h-2"></span>
                                    </div>
                                )}
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuComponent;